import * as React from "react";
import { ResetIcon } from "@radix-ui/react-icons";
import { useMutation } from "convex/react";
import { api } from "@repo/convex/convex/_generated/api";
import { toast } from "sonner";
import { ItemCard } from "../common/items/ItemCard.tsx";
import { TrashedItemDoc } from "@repo/convex/convex/schema.ts";
import { ItemMenu } from "../common/items/ItemMenu.tsx";
import { PermanentlyDeleteMenuItem } from "./PermanentlyDeleteMenuItem.tsx";
import { CommonMenuItems } from "../common/items/menu/CommonMenuItems.tsx";
import { ItemNotesActionButton } from "../common/items/ItemNotesActionButton.tsx";
import { CardIconButton, ItemActions } from "../common/items/ItemActions.tsx";
import { ListedItem } from "@repo/convex/convex/items.ts";
import { deletesIn } from "../common/items/format.ts";

interface Props {
  item: ListedItem<TrashedItemDoc>;
}

export const TrashedItem: React.FC<Props> = ({ item }) => {
  const restore = useMutation(api.items.restoreMine);
  const trash = useMutation(api.items.trash);

  return (
    <ItemCard
      item={item}
      detail={`Gone ${deletesIn(item.status.willBeDeletedAt)}`}
      actions={
        <ItemActions>
          {item.hasNotes ? <ItemNotesActionButton itemId={item._id} /> : null}
          <CardIconButton
            label="Restore"
            onClick={() =>
              restore({ itemId: item._id })
                .then(() =>
                  toast.success(
                    item.status.restoreToStatus.kind == "archived"
                      ? "Back in the archive"
                      : "Back in the stash",
                    {
                      action: {
                        label: "Undo",
                        onClick: () => trash({ itemId: item._id }).catch(toast.error),
                      },
                    },
                  ),
                )
                .catch(console.error)
            }
          >
            <ResetIcon />
          </CardIconButton>
        </ItemActions>
      }
      menu={
        <ItemMenu>
          <CommonMenuItems item={item} />
          <PermanentlyDeleteMenuItem item={item} />
        </ItemMenu>
      }
    />
  );
};
